"use client";
import { LinkedinShareButton, TwitterShareButton, FacebookShareButton, BlueskyShareButton } from "react-share";
import { LinkedInIcon, TwitterIcon, FacebookIcon, BlueskyIcon } from "~/components/icons";


const SocialShareLinks = ({ path }) => {
  return (
    <div>
      <div className="group py-2 md:py-3 md:border-b border-b-black">
        <TwitterShareButton url={`https://outshift.cisco.com/blog/${path}`}>
          <div className="flex items-center gap-2">
            <div className="ml-1 flex h-[35px] w-[35px] md:h-[40px] md:w-[40px] cursor-pointer items-center justify-center  rounded-full bg-black group-hover:bg-gray-700 p-2 text-white">
              <TwitterIcon color="white" />
            </div>
            <p className="font-p w-[170px] text-left text-black hidden md:block">Twitter</p>
          </div>
        </TwitterShareButton>
      </div>
      <div className="group py-2 md:py-3 md:border-b border-b-black">
        <LinkedinShareButton url={`https://outshift.cisco.com/blog/${path}`}>
          <div className="flex items-center gap-2">
            <div className="ml-1 flex h-[35px] w-[35px] md:h-[40px] md:w-[40px] cursor-pointer items-center justify-center  rounded-full bg-black group-hover:bg-gray-700 p-2 text-white">
              <LinkedInIcon color="white" />
            </div>
            <p className="font-p w-[170px] text-left text-black hidden md:block">LinkedIn</p>
          </div>
        </LinkedinShareButton>
      </div>
      <div className="group py-2 md:py-3 md:border-b border-b-black">
        <FacebookShareButton url={`https://outshift.cisco.com/blog/${path}`}>
          <div className="flex items-center gap-2">
            <div className="ml-1 flex h-[35px] w-[35px] md:h-[40px] md:w-[40px] cursor-pointer items-center justify-center  rounded-full bg-black group-hover:bg-gray-700 p-2 text-white">
              <FacebookIcon color="white" />
            </div>
            <p className="font-p w-[170px] text-left text-black hidden md:block">Facebook</p>
          </div>
        </FacebookShareButton>
      </div>
      
      <div className="group py-2 md:py-3 ">
        <BlueskyShareButton url={`https://outshift.cisco.com/blog/${path}`}>
          <div className="flex items-center gap-2">
            <div className="ml-1 flex h-[35px] w-[35px] md:h-[40px] md:w-[40px] cursor-pointer items-center justify-center  rounded-full bg-black group-hover:bg-gray-700 p-2 text-white">
              <BlueskyIcon color="white" />
            </div>
            <p className="font-p w-[170px] text-left text-black hidden md:block">Bluesky</p>
          </div>
        </BlueskyShareButton>
      </div>
    </div>
  );
};

export default SocialShareLinks;
